export default "__VITE_ASSET__85385c25__"